export type StreamErrorClassification =
    | "aborted"
    | "network"
    | "thread_busy"
    | "unknown";

export class ThreadBusyError extends Error {
    constructor() {
        super("thread_busy");
        this.name = "ThreadBusyError";
    }
}

export const isThreadBusyResponse = async (
    response: Response
): Promise<boolean> => {
    if (response.status !== 409) return false;
    try {
        const body = await response.clone().json();
        return body?.error === "thread_busy";
    } catch {
        return false;
    }
};

const NETWORK_ERROR_MESSAGES = new Set([
    "network error",
    "load failed",
    "failed to fetch",
    "networkerror when attempting to fetch resource.",
]);

export const classifyStreamError = (
    error: unknown
): StreamErrorClassification => {
    if (!(error instanceof Error)) {
        return "unknown";
    }

    if (error instanceof ThreadBusyError) {
        return "thread_busy";
    }

    if (error.name === "AbortError") {
        return "aborted";
    }

    if (
        error instanceof TypeError &&
        NETWORK_ERROR_MESSAGES.has(error.message.trim().toLowerCase())
    ) {
        return "network";
    }

    return "unknown";
};
